import validation from '../../../../../modules/Gull/Framework/validation.js';

const endView = {

	init() {

		// Het beëindigen van een melding bij een werknemer.
		$('body').on('change', '#EindReden,#Einddatum', function() {
			$('.alert-confirmation').closest('.row').addClass('d-none');
			if (($('#EindReden').val() != '') && ($('#Einddatum').val() != '')) {
				var reden = $('#EindReden option[value=' + $('#EindReden').val() + ']').html();
				var eindDatumArray = $('#Einddatum').val().split('-');
				var datum = new Date(eindDatumArray[2] + '-' + eindDatumArray[1] + '-' + eindDatumArray[0]);
				var today = new Date();
				if (datum > today) {
					$('#toelichtingEindmeldingToekomst').closest('.row').removeClass('d-none');
					validation.addRequired($('#toelichtingEindmeldingToekomst'));

				} else {
					$('#toelichtingEindmeldingToekomst').closest('.row').addClass('d-none');
					validation.removeRequired($('#toelichtingEindmeldingToekomst'));
				}

				datum.setDate(datum.getDate() + 1);
				datum = datum.getDate() + '-' + (datum.getUTCMonth() + 1) + '-' + datum.getFullYear();
				if (typeof reden !== 'undefined' && reden != '') {
					if (reden != 'Overig') {
						if (reden.charAt(0) != 'W' && reden.charAt(0) != 'I' && reden.charAt(0) != 'A') {
							$('.alert-confirmation').find('span').html(datum + ' ' + reden.charAt(0).toLowerCase() + reden.slice(1));
						} else {
							$('.alert-confirmation').find('span').html(datum + ' ' + reden);
						}
						$('.alert-confirmation').closest('.row').removeClass('d-none');
					}
				}
			}
		});
		$('#Einddatum').trigger('change');

		// Toon of verberg het blok voor overlappend dienstverband op basis van de begindatum voor een nieuw dienstverband en de einddatum van reeds bestaande dienstverbanden.
		$('#beeindig-arbeidsovereenkomst-button').click(function(e) {
			e.preventDefault();
			$.getJSON($(this).attr('href'), function(data) {
				if (data != false) {
					$('#modalBeeindigArbeidsovereenkomst').modal('toggle');
				}
			});
		});

		// Open modal waarschuwing dat er een lopende melding is
		if ($('#modalBeeindigArbeidsovereenkomst').length) {
			$('#modalBeeindigArbeidsovereenkomst').modal('show', {
				keyboard: false,
				backdrop: 'static'
			});
		}

	}

};

export default endView;
